const DAY_MS = 86_400_000;

/**
 * The calendar days from today to the release day. A release date is a day, not a moment, so the
 * date part of the ISO value is compared with the viewer's own day. 0 is today, a negative number
 * is a release in the past, null is no release date.
 */
export function daysUntilRelease(releaseDate: string | null, now: Date): number | null {
  if (releaseDate === null) {
    return null;
  }
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(releaseDate);
  if (match === null) {
    return null;
  }
  const release = Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((release - today) / DAY_MS);
}
